import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";

/**
 * Barre de navigation publique unique, utilisée par TOUTES les pages
 * publiques du site (accueil, tarifs, horaires, véhicules, marchandises,
 * contact, connexion, inscription, mot de passe oublié, vérification de
 * compte, mentions légales) - logo et menu strictement identiques partout,
 * pour éviter les incohérences repérées page par page (émoji ici, icône
 * différente là, menu absent ailleurs).
 *
 * Le logo respecte celui configuré par l'administrateur (Paramètres) s'il
 * existe ; sinon il retombe sur l'icône + texte "SETRAG / TRANSGABONAIS"
 * par défaut.
 */
const C = { green: "#006B3C", greenDk: "#004D2B", yellow: "#FFC300", white: "#FFFFFF" };

const Icon = ({ d, size = 20, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...props}>
    {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
  </svg>
);
const TrainIcon     = ({ size }) => <Icon size={size || 22} d={["M4 4h16a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2z", "M8 17l-2 3", "M16 17l2 3", "M2 11h20", "M9 4v7", "M15 4v7"]} />;
const HamburgerIcon = ({ size }) => <Icon size={size || 22} d={["M4 6h16M4 12h16M4 18h16"]} />;

const NAV_LINKS = [
  ["Accueil", "/"],
  ["Tarifs", "/tarifs"],
  ["Véhicules", "/vehicules"],
  ["Marchandises", "/marchandises"],
  ["Contact", "/contact"],
];

const useWindowWidth = () => {
  const [w, setW] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
  useEffect(() => {
    const h = () => setW(window.innerWidth);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);
  return w;
};

export default function PublicNav() {
  const navigate = useNavigate();
  const { settings } = useSettings();
  const w = useWindowWidth();
  const isMobile = w < 768;
  const [mobileMenu, setMobileMenu] = useState(false);

  return (
    <nav style={{ background: C.green, padding: "0 16px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 64, position: "sticky", top: 0, zIndex: 100, boxShadow: "0 2px 8px rgba(0,0,0,0.2)" }}>
      {mobileMenu && (
        <div style={{ position: "absolute", top: 64, left: 0, right: 0, background: C.green, padding: 20, display: "flex", flexDirection: "column", gap: 20, zIndex: 200, boxShadow: "0 8px 20px rgba(0,0,0,0.25)" }}>
          {NAV_LINKS.map(([label, path]) => (
            <a key={path} href={path} style={{ color: "#fff", fontSize: 16, textDecoration: "none", fontWeight: 500 }} onClick={() => setMobileMenu(false)}>{label}</a>
          ))}
          <button onClick={() => { setMobileMenu(false); navigate("/login"); }} style={{ background: C.yellow, color: C.greenDk, border: "none", borderRadius: 20, padding: "10px", fontWeight: 700, cursor: "pointer" }}>Se connecter</button>
        </div>
      )}

      <a href="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
        {settings.logoUrl ? (
          <img src={settings.logoUrl} alt="SETRAG" style={{ height: 34, maxWidth: 120, objectFit: "contain" }} />
        ) : (
          <>
            <span style={{ color: "#fff", display: "flex" }}><TrainIcon size={22} /></span>
            <div>
              <div style={{ fontWeight: 800, fontSize: 16, color: C.white }}>SETRAG</div>
              <div style={{ fontSize: 9, color: "rgba(255,255,255,0.7)" }}>TRANSGABONAIS</div>
            </div>
          </>
        )}
      </a>

      {!isMobile && (
        <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
          {NAV_LINKS.map(([label, path]) => (
            <a key={path} href={path} style={{ color: "rgba(255,255,255,0.85)", fontSize: 14, fontWeight: 500, textDecoration: "none" }}>{label}</a>
          ))}
          <button onClick={() => navigate("/login")} style={{ background: C.yellow, color: C.greenDk, border: "none", borderRadius: 20, padding: "8px 18px", fontWeight: 700, cursor: "pointer", fontSize: 13, whiteSpace: "nowrap" }}>Se connecter</button>
        </div>
      )}
      {isMobile && (
        <button onClick={() => setMobileMenu(p => !p)} style={{ background: "none", border: "none", color: "#fff", cursor: "pointer" }}><HamburgerIcon /></button>
      )}
    </nav>
  );
}
